import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { MessageCircle } from "lucide-react";

/**
 * Botão flutuante de atendimento WhatsApp — número oficial do VM Piabetá Shopping.
 * Busca o número dinamicamente em `/whatsapp/atendimento/publico`, com fallback
 * hard-coded para (21) 98735-6892 caso a API esteja fora do ar.
 */
export default function FloatingWhatsAppButton({ mensagemInicial = "" }) {
  const [config, setConfig] = useState({
    display: "(21) 98735-6892",
    wa_me_link: "https://wa.me/5521987356892",
  });

  useEffect(() => {
    let ativo = true;
    api.get("/whatsapp/atendimento/publico").then(({ data }) => {
      if (ativo && data?.wa_me_link) setConfig(data);
    }).catch(() => { /* usa fallback */ });
    return () => { ativo = false; };
  }, []);

  const href = mensagemInicial
    ? `${config.wa_me_link}?text=${encodeURIComponent(mensagemInicial)}`
    : config.wa_me_link;

  return (
    <a
      href={href}
      target="_blank"
      rel="noreferrer"
      data-testid="floating-whatsapp"
      title={`Atendimento WhatsApp ${config.display}`}
      className="fixed bottom-6 right-6 z-40 flex items-center gap-2 rounded-full bg-[#25d366] hover:bg-[#20b358] text-white shadow-lg h-14 px-5 no-print transition-transform hover:scale-105"
    >
      <MessageCircle size={22} strokeWidth={2.5} />
      <span className="text-xs font-semibold hidden sm:inline">
        Falar com atendimento
      </span>
    </a>
  );
}
